// import { BaseSyntheticEvent } from 'react'
// // Interfaces
// import { IMovie } from 'interfaces/IMovie'
// // Components
// import { LazyLoadImage, trackWindowScroll } from 'react-lazy-load-image-component'
// // Images
// import { Dummy } from '@/assets/images'
//
// // Local Interfaces
// interface IProps {
//   movie: IMovie
//   isRecent: boolean
//   handleClick(item: IMovie, isRecent: boolean): unknown
// }
//
// const MovieListSearch = (props: IProps) => {
//   const { movie, isRecent = false, handleClick } = props
//
//   return (
//     <div
//       role='button'
//       tabIndex={0}
//       className='flex justify-between cursor-pointer'
//       onClick={() => handleClick(movie, isRecent)}
//     >
//       <div className='flex space-x-2'>
//         {/* Image */}
//         <LazyLoadImage
//           src={`https://www.themoviedb.org/t/p/w220_and_h330_face${movie.poster_path}`}
//           alt={movie.title || movie.original_title || movie.original_name}
//           useIntersectionObserver={true}
//           threshold={100}
//           placeholderSrc={<div className='bg-slate-300 dark:bg-slate-800 animate-pulse' />}
//           onError={(event: BaseSyntheticEvent) => {
//             event.currentTarget.onerror = null
//             event.currentTarget.src = Dummy
//           }}
//           className='w-12 min-w-[48px] h-[72px] object-center object-cover rounded shadow-lg'
//         />
//
//         {/* Title & release year */}
//         <div className='flex flex-col'>
//           <p className='text-slate-900 dark:text-slate-100 line-clamp-1'>
//             {movie.title || movie.name}
//           </p>
//           <p className='text-sm text-slate-600 dark:text-zinc-400'>
//             {movie.release_date?.split('-')[0] || movie.first_air_date?.split('-')[0]}
//           </p>
//         </div>
//       </div>
//
//       <div
//         className={`flex justify-center items-center md:text-xs text-[10px] text-slate-100 md:min-w-[68px] min-w-[60px] md:max-w-[68px] max-w-[60px] md:h-7 h-5 mx-2 rounded-full ${
//           movie.first_air_date ? 'bg-blue-600' : 'bg-violet-600'
//         }`}
//       >
//         {movie.first_air_date ? 'TV Show' : 'Movie'}
//       </div>
//     </div>
//   )
// }
//
// export default trackWindowScroll(MovieListSearch)

import { IMovie } from 'interfaces/IMovie'
import { LazyLoadImage, trackWindowScroll } from 'react-lazy-load-image-component'
import { Dummy } from '@/assets/images'

interface IProps {
  movie: IMovie
  isRecent?: boolean
  handleClick(item: IMovie, isRecent: boolean): void
}

const POSTER_FALLBACK = Dummy

function resolvePosterSrc(poster_path?: string | null): string {
  if (!poster_path) return POSTER_FALLBACK
  // Sanity (absolute URL)
  if (/^https?:\/\//i.test(poster_path)) return poster_path
  // TMDB (relative path like "/abc123.jpg")
  return `https://image.tmdb.org/t/p/w220_and_h330_face${poster_path}`
}

const MovieListSearch = ({ movie, isRecent = false, handleClick }: IProps) => {
  const imgSrc = resolvePosterSrc(movie.poster_path)
  const title =
    movie.title ||
    (movie as any).original_title ||
    (movie as any).original_name ||
    movie.name ||
    'Title'
  const year =
    movie.release_date?.split('-')[0] || (movie as any).first_air_date?.split('-')[0] || ''

  const isTv = Boolean((movie as any).first_air_date)

  return (
    <button
      type='button'
      onClick={() => handleClick(movie, isRecent)}
      className='w-full flex justify-between items-center gap-2 rounded-sm p-2 hover:bg-black/5 dark:hover:bg-white/5'
    >
      <div className='flex items-center gap-2'>
        <LazyLoadImage
          src={imgSrc}
          alt={title}
          effect='opacity'
          placeholderSrc={POSTER_FALLBACK}
          onError={(e: any) => {
            e.currentTarget.src = POSTER_FALLBACK
          }}
          className='w-12 min-w-[48px] h-[72px] object-cover rounded-sm shadow-lg bg-slate-200 dark:bg-slate-800'
        />

        <div className='min-w-0'>
          <p className=' text-sm text-slate-900 dark:text-slate-100 truncate'>{title}</p>
          {!!year && <p className='text-sm text-slate-600 dark:text-zinc-400'>{year}</p>}
        </div>
      </div>

      <span
        className='flex justify-center items-center md:text-xs text-[10px] text-white
                    md:min-w-[68px] min-w-[60px] md:max-w-[68px] max-w-[60px] md:h-7 h-5 mx-2 rounded-sm
                    bg-blue-600'
      >
        {isTv ? 'TV Show' : 'Movie'}
      </span>
    </button>
  )
}

export default trackWindowScroll(MovieListSearch)
